import { render, staticRenderFns } from "./AdminDispatchReservations.vue?vue&type=template&id=825beb9c&scoped=true"
import script from "./AdminDispatchReservations.vue?vue&type=script&lang=js"
export * from "./AdminDispatchReservations.vue?vue&type=script&lang=js"
import style0 from "./AdminDispatchReservations.vue?vue&type=style&index=0&id=825beb9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825beb9c",
  null
  
)

export default component.exports